(() => {
  const routes = window.kulaniRoutes;
  const header = document.querySelector('[data-header]');
  const nav = document.getElementById('KulaniNavigation');
  const toggle = document.querySelector('[data-menu-toggle]');
  const closeMenu = () => { nav?.classList.remove('is-open'); toggle?.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; nav?.querySelectorAll('.kk-nav-item.is-open').forEach(item=>item.classList.remove('is-open')); nav?.querySelectorAll('.kk-submenu-toggle').forEach(button=>{button.setAttribute('aria-expanded','false');button.textContent='+';}); };
  toggle?.addEventListener('click', () => { const open = !nav.classList.contains('is-open'); nav.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', String(open)); document.body.style.overflow = open ? 'hidden' : ''; if (open) nav.querySelector('button, a')?.focus(); });
  document.querySelector('[data-menu-close]')?.addEventListener('click', () => { closeMenu(); toggle?.focus(); });
  nav?.addEventListener('keydown', event => { if(event.key !== 'Tab' || !nav.classList.contains('is-open')) return; const elements=[...nav.querySelectorAll('a,button')].filter(e=>e.getClientRects().length); const first=elements[0],last=elements.at(-1); if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();} });
  document.querySelectorAll('.kk-submenu-toggle').forEach(button => button.addEventListener('click', () => {const item=button.closest('.kk-nav-item'); const open=!item.classList.contains('is-open');item.classList.toggle('is-open',open);button.setAttribute('aria-expanded',String(open));button.textContent=open?'−':'+';}));
  document.querySelectorAll('.kk-nav-item').forEach(item=>{item.addEventListener('mouseenter',()=>item.classList.remove('is-dismissed'));item.addEventListener('focusin',()=>item.classList.remove('is-dismissed'));});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const focusInMenu=nav?.contains(document.activeElement);closeMenu();if(window.matchMedia('(min-width:1000px)').matches)nav?.querySelectorAll('.kk-nav-item').forEach(item=>item.classList.add('is-dismissed'));if(focusInMenu){if(window.matchMedia('(max-width:999px)').matches)toggle?.focus();else document.querySelector('.kk-logo')?.focus();}}});
  const scrollHeader=()=>header?.classList.toggle('is-scrolled',window.scrollY>30);scrollHeader();window.addEventListener('scroll',scrollHeader,{passive:true});
  document.querySelector('#CollectionFilters form')?.addEventListener('submit',event=>{
    event.preventDefault();const form=event.currentTarget,url=new URL(form.action,location.href);url.search='';
    for(const [name,value] of new FormData(form))if(String(value).trim())url.searchParams.append(name,value);
    location.assign(url.href);
  });
  const filterButton=document.querySelector('[data-filter-toggle]');
  const filterPanel=document.getElementById('CollectionFilters');const filterBackdrop=document.querySelector('.kk-filter-backdrop');
  const closeFilters=()=>{if(!filterPanel)return;filterPanel.hidden=true;if(filterBackdrop)filterBackdrop.hidden=true;filterButton?.setAttribute('aria-expanded','false');document.body.style.overflow='';filterButton?.focus();};
  filterButton?.addEventListener('click',()=>{if(!filterPanel)return;filterPanel.hidden=false;if(filterBackdrop)filterBackdrop.hidden=false;filterButton.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';filterPanel.querySelector('[data-filter-close]')?.focus();});
  document.querySelectorAll('[data-filter-close]').forEach(button=>button.addEventListener('click',closeFilters));
  filterPanel?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();closeFilters();}if(event.key==='Tab'){const elements=[...filterPanel.querySelectorAll('a,button,input,summary')].filter(e=>!e.disabled&&e.getClientRects().length),first=elements[0],last=elements.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}}});
  window.kulaniInitCardGalleries=(root=document)=>{
  root.querySelectorAll('[data-card-gallery]').forEach(gallery=>{
    const slides=[...gallery.querySelectorAll('[data-card-slide]')];
    if(slides.length<2)return;
    let frame=0;
    const updateSlideAccess=()=>{
      cancelAnimationFrame(frame);
      frame=requestAnimationFrame(()=>{
        const active=Math.min(slides.length-1,Math.max(0,Math.round(gallery.scrollLeft/gallery.clientWidth)));
        slides.forEach((slide,index)=>{
          const visible=index===active;
          slide.tabIndex=visible?0:-1;
          slide.setAttribute('aria-hidden',String(!visible));
        });
      });
    };
    gallery.addEventListener('scroll',updateSlideAccess,{passive:true});
    gallery.closest('[data-product-card]')?.querySelectorAll('[data-card-gallery-step]').forEach(button=>{
      button.addEventListener('click',()=>{
        const current=Math.round(gallery.scrollLeft/gallery.clientWidth);
        const direction=Number(button.dataset.cardGalleryStep)||1;
        const next=(current+direction+slides.length)%slides.length;
        gallery.scrollTo({left:next*gallery.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      });
    });
  });
  };window.kulaniInitCardGalleries();
  document.querySelectorAll('[data-facet-search]').forEach(input=>input.addEventListener('input',()=>{const query=input.value.trim().toLowerCase();input.closest('[data-filter-group]').querySelectorAll('.kk-filter-values label').forEach(label=>label.hidden=!label.querySelector('span').textContent.toLowerCase().includes(query));}));
  const money = cents => new Intl.NumberFormat(routes.locale || 'en', {style:'currency',currency:routes.currency||'USD'}).format(cents / 100) + ' ' + (routes.currency||'USD');
  const updateCartBadge = count => document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.hidden = count === 0;
  });
  let cartOpener = null;
  let priorBodyOverflow = '';
  const drawerPanel = () => document.querySelector('[data-cart-drawer] .kk-cart-drawer__panel');
  const openCartDrawer = () => {
    const root = document.querySelector('[data-cart-drawer]');
    const panel = drawerPanel();
    if (!root || !panel) return false;
    cartOpener = document.activeElement;
    panel.hidden = false;
    root.querySelector('.kk-cart-drawer__backdrop').hidden = false;
    requestAnimationFrame(() => panel.setAttribute('aria-hidden', 'false'));
    document.body.classList.add('kk-cart-open');
    priorBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-cart-drawer-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
    panel.querySelector('[data-cart-drawer-close]')?.focus();
    loadRecommendations(root);
    updateShippingProgress(root);
    return true;
  };
  const closeCartDrawer = (restoreFocus = true) => {
    const root = document.querySelector('[data-cart-drawer]');
    const panel = drawerPanel();
    if (!root || !panel || panel.hidden) return;
    panel.setAttribute('aria-hidden', 'true');
    root.querySelector('.kk-cart-drawer__backdrop').hidden = true;
    document.body.classList.remove('kk-cart-open');
    document.body.style.overflow = priorBodyOverflow;
    document.querySelectorAll('[data-cart-drawer-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { if (panel.getAttribute('aria-hidden') === 'true') panel.hidden = true; }, 300);
    if (restoreFocus) (cartOpener?.isConnected ? cartOpener : document.querySelector('[data-cart-drawer-open]'))?.focus();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('a.kk-cart-link[data-cart-drawer-open]') && openCartDrawer()) event.preventDefault();
    if (event.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });
  document.addEventListener('keydown', event => {
    const panel = drawerPanel();
    if (event.key === 'Escape' && panel && !panel.hidden) { closeCartDrawer(); return; }
    if (event.key !== 'Tab' || !panel || panel.hidden) return;
    const focusable = [...panel.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled)')].filter(el => el.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  const recommendationCache = new Map();
  const loadRecommendations = async root => {
    const productId = root?.dataset.recommendationProduct;
    const container = root?.querySelector('[data-cart-recommendations]');
    const grid = root?.querySelector('[data-recommendation-grid]');
    if (!productId || !container || !grid || grid.childElementCount) return;
    try {
      let products = recommendationCache.get(productId);
      if (!products) {
        const url = new URL(`${routes.root}recommendations/products.json`, location.origin);
        url.searchParams.set('product_id', productId);
        url.searchParams.set('limit', '4');
        url.searchParams.set('intent', 'complementary');
        const response = await fetch(url, {headers:{Accept:'application/json'}});
        if (!response.ok) return;
        products = (await response.json()).products || [];
        recommendationCache.set(productId, products);
      }
      const cartResponse = await fetch(`${routes.root.replace(/\/$/,'')}/cart.js`, {headers:{Accept:'application/json'}});
      const cart = cartResponse.ok ? await cartResponse.json() : {items:[]};
      const inCart = new Set((cart.items || []).map(item => String(item.product_id)));
      products.filter(product => product.available && !inCart.has(String(product.id))).slice(0, 2).forEach(product => {
        const variant = product.variants?.find(item => item.available) || product.variants?.[0];
        if (!variant) return;
        const card = document.createElement('article'); card.className = 'kk-cart-drawer__recommendation';
        const imageLink = document.createElement('div'); imageLink.className = 'kk-cart-drawer__recommendation-image';
        const productLink = document.createElement('a'); productLink.href = product.url; productLink.setAttribute('aria-label', product.title);
        if (product.featured_image) { const image = document.createElement('img'); image.src = product.featured_image; image.alt = product.title; image.loading = 'lazy'; productLink.append(image); }
        const add = document.createElement('button'); add.type = 'button'; add.className = 'kk-cart-drawer__recommendation-add'; add.dataset.recommendationAdd = ''; add.dataset.variantId = variant.id; add.setAttribute('aria-label', `Add ${product.title} to bag`); add.textContent = '＋'; imageLink.append(productLink, add);
        const title = document.createElement('h4'); title.textContent = product.title;
        const color = document.createElement('p'); color.textContent = product.variants?.[0]?.title === 'Default Title' ? '' : (product.variants?.[0]?.title || '');
        const price = document.createElement('strong'); price.textContent = `${product.price} ${routes.currency || ''}`.trim();
        card.append(imageLink, title, color, price); grid.append(card);
      });
      container.hidden = grid.childElementCount === 0;
    } catch (_) { /* Keep the bag usable if recommendations are unavailable. */ }
  };
  const updateShippingProgress = root => {
    const message = root?.querySelector('[data-shipping-message]');
    const bar = root?.querySelector('[data-shipping-bar]');
    const progress = bar?.parentElement;
    if (!message || !bar || !progress) return;
    const total = Number(root.dataset.cartTotal || 0) / 100;
    const threshold = Number(root.dataset.threshold || 0) / 100;
    const remaining = Math.max(0, threshold - total);
    const percent = threshold ? Math.min(100, total / threshold * 100) : 100;
    message.textContent = threshold > 0 && remaining ? `You are ${new Intl.NumberFormat(routes.locale || 'en', {style:'currency',currency:routes.currency || 'USD'}).format(remaining)} away from unlocking free shipping!` : 'Free shipping on all orders.';
    bar.style.width = `${percent}%`;
    progress.setAttribute('aria-valuenow', String(Math.round(percent)));
  };
  const refreshCartSection = async section => {
    const wasOpen = section.matches('[data-cart-drawer]') && section.querySelector('.kk-cart-drawer__panel')?.getAttribute('aria-hidden') === 'false';
    const url = new URL(routes.cart, window.location.origin);
    url.searchParams.set('sections', section.dataset.sectionId);
    const response = await fetch(url, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Your bag changed, but it could not be refreshed.');
    const sections = await response.json();
    const html = sections[section.dataset.sectionId];
    if (!html) throw new Error('The updated bag could not be displayed.');
    const documentFromResponse = new DOMParser().parseFromString(html, 'text/html');
    const replacement = documentFromResponse.querySelector('[data-cart-section]');
    if (!replacement) throw new Error('The updated bag could not be displayed.');
    section.replaceWith(replacement);
    if (replacement.matches('[data-cart-drawer]')) {
      if (wasOpen) {
        const panel = replacement.querySelector('.kk-cart-drawer__panel');
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        replacement.querySelector('.kk-cart-drawer__backdrop').hidden = false;
      }
      updateShippingProgress(replacement);
      if (wasOpen) loadRecommendations(replacement);
    }
    return replacement;
  };
  const updateCart = async (form, values, focusKey = '') => {
    const section = form.closest('[data-cart-section]');
    const feedback = section?.querySelector('[data-cart-feedback]');
    if (!section || form.dataset.updating === 'true') return;
    let cartUpdated = false;
    form.dataset.updating = 'true';
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('button, input').forEach(control => { control.disabled = true; });
    if (feedback) feedback.textContent = 'Updating your bag…';
    try {
      const response = await fetch(routes.cartUpdate, {
        method:'POST',
        headers:{Accept:'application/json','Content-Type':'application/json'},
        body:JSON.stringify({updates:values})
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to update your bag.');
      cartUpdated = true;
      updateCartBadge(cart.item_count);
      const updatedSection = await refreshCartSection(section);
      if (focusKey) {
        const matchingInput = [...updatedSection.querySelectorAll('[data-cart-quantity]')].find(input => input.dataset.lineKey === focusKey);
        (matchingInput || updatedSection.querySelector('[data-cart-quantity], .kk-cart__empty a, h1'))?.focus();
      }
    } catch (error) {
      if (cartUpdated || error instanceof TypeError) {
        // The cart update may have succeeded before a section refresh failed. Reload the server-rendered cart.
        window.location.reload();
        return;
      }
      if (feedback) feedback.textContent = error.message;
      form.dataset.updating = 'false';
      form.removeAttribute('aria-busy');
      form.querySelectorAll('button, input').forEach(control => { control.disabled = false; });
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-cart-form]');
    if (!form || event.submitter?.name === 'checkout' || !window.fetch) return;
    event.preventDefault();
    const values = Object.fromEntries([...form.querySelectorAll('[data-cart-quantity]')].map(input => [input.dataset.lineKey, Math.max(1, Number.parseInt(input.value, 10) || 1)]));
    updateCart(form, values, document.activeElement?.dataset?.lineKey || '');
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-quantity]');
    const form = input?.closest('[data-cart-form]');
    if (!input || !form || !window.fetch) return;
    const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
    input.value = quantity;
    updateCart(form, {[input.dataset.lineKey]:quantity}, input.dataset.lineKey);
  });
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    const step = event.target.closest('[data-cart-step]');
    const recommendation = event.target.closest('[data-recommendation-add]');
    if (remove && window.fetch) {
      event.preventDefault();
      const form = remove.closest('[data-cart-form]');
      if (form) updateCart(form, {[remove.dataset.lineKey]:0});
    }
    if (step && window.fetch) {
      const form = step.closest('[data-cart-form]');
      const input = [...form.querySelectorAll('[data-cart-quantity]')].find(field => field.dataset.lineKey === step.dataset.lineKey);
      if (input) updateCart(form, {[step.dataset.lineKey]:Math.max(0, Number(input.value) + Number(step.dataset.cartStep))}, step.dataset.lineKey);
    }
    if (recommendation) addRecommendation(recommendation);
  });
  const addRecommendation = async button => {
    button.disabled = true;
    const root = button.closest('[data-cart-drawer]');
    try {
      const response = await fetch(routes.cartAdd, {method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.variantId,quantity:1})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
      const cartResponse = await fetch(`${routes.root.replace(/\/$/,'')}/cart.js`, {headers:{Accept:'application/json'}});
      if (cartResponse.ok) updateCartBadge((await cartResponse.json()).item_count);
      if (root) await refreshCartSection(root);
    } catch (error) {
      button.disabled = false;
      const feedback = root?.querySelector('[data-cart-feedback]');
      if (feedback) feedback.textContent = error.message;
    }
  };
  const refreshCurrentCart = async (shouldOpen = false) => {
    try {
      const response = await fetch(`${routes.root.replace(/\/$/,'')}/cart.js`, {headers:{Accept:'application/json'}});
      if (response.ok) updateCartBadge((await response.json()).item_count);
    } catch (_) { /* A successful add can still be rendered through the cart section endpoint. */ }
    const root = document.querySelector('[data-cart-drawer]');
    if (root) {
      try { await refreshCartSection(root); }
      catch (_) { window.location.reload(); return; }
    }
    if (shouldOpen) openCartDrawer();
  };
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.kk-card__quick-add-form');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const originalText = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
    try {
      const response = await fetch(routes.cartAdd, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
      await refreshCurrentCart(true);
    } catch (error) {
      const status = form.querySelector('[data-quick-add-status]') || document.createElement('p');
      status.dataset.quickAddStatus = '';
      status.setAttribute('role','status');
      status.textContent = error.message;
      if (!status.isConnected) form.append(status);
    } finally {
      if (button) { button.disabled = false; button.textContent = originalText; }
    }
  });
  window.kulaniInitProductForm=(root=document)=>{
  root.querySelectorAll('[data-product-section]').forEach(section=>{
    const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const form=section.querySelector('.kk-product-form');const input=form.querySelector('[data-variant-input]');const button=form.querySelector('[data-add-to-cart]');const status=form.querySelector('[data-product-status]');
    const renderVariant=()=>{
      const options=[...form.querySelectorAll('[data-option-index]')].map(field=>field.querySelector('input:checked')?.value);
      const variant=options.length?variants.find(v=>v.options.every((option,index)=>option===options[index])):variants[0];
      input.value=variant?.id||'';button.disabled=!variant?.available;button.textContent=variant?(variant.available?'ADD TO CART':'SOLD OUT'):'UNAVAILABLE';status.textContent='';
      if(!variant)return;
      const price=section.querySelector('[data-price]');price.replaceChildren();const current=document.createElement('span');current.textContent=money(variant.price);price.append(current);
      const badgeHost=section.querySelector('[data-product-badge]');badgeHost.replaceChildren();
      if(variant.compare_at_price>variant.price){const compare=document.createElement('s');compare.textContent=money(variant.compare_at_price);price.append(compare);const badge=document.createElement('span');badge.className='kk-discount-badge';badge.textContent=Math.round((1-variant.price/variant.compare_at_price)*100)+'% OFF';badgeHost.append(badge);}
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      section.dispatchEvent(new CustomEvent('variant:change',{detail:variant}));
    };
    form.addEventListener('change',event=>{if(event.target.matches('[data-option-index] input'))renderVariant();});
    form.addEventListener('submit',async event=>{
      if(!window.fetch)return;event.preventDefault();button.disabled=true;status.textContent='Adding to your bag…';
      try {const response=await fetch(routes.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Unable to add this item.');status.textContent='Added to your bag. ';const link=document.createElement('a');link.href=routes.cart;link.textContent='VIEW BAG';status.append(link);await refreshCurrentCart(true);}
      catch(error){status.textContent=error.message;}finally{button.disabled=!input.value||!variants.find(v=>String(v.id)===input.value)?.available;}
    });
  });
  };window.kulaniInitProductForm();
  const videoObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{entries.forEach(({target,isIntersecting})=>{if(!isIntersecting)return;target.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;source.removeAttribute('data-src');});target.load();target.play().catch(()=>{});videoObserver.unobserve(target);});},{rootMargin:'200px'}):null;
  document.querySelectorAll('.js-videoLazy').forEach(video=>videoObserver?.observe(video));
  document.querySelectorAll('.shopify-section').forEach(section=>{
    const slider=section.querySelector('[id^="Slider-"]');if(!slider)return;const controls=[...section.querySelectorAll('button')].filter(button=>/previous|next/i.test(button.getAttribute('aria-label')||''));controls.forEach(button=>button.addEventListener('click',()=>slider.scrollBy({left:(/previous/i.test(button.getAttribute('aria-label'))?-1:1)*slider.clientWidth*.8,behavior:'smooth'})));
  });
})();

